import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from '../../../../components/layout/menu';
import { axiosInstance } from '../../../../client';
import 'react-quill/dist/quill.snow.css';
import { Types } from '../../../../constants/announcementTypes';
import { downloadExcel } from '../../../../utils/xlsxUtils';
import Modals from '../../../../components/announcements/Modals';
import dangerIcon from "../../../../assets/images/icons/announcements/danger.svg";
import alertIcon from "../../../../assets/images/icons/announcements/alert.svg";
import checkIcon from "../../../../assets/images/icons/announcements/check.svg";
import formIcon from "../../../../assets/images/icons/announcements/form.svg";
import { republishValidation } from '../../../../hooks/announcements/useAnnouncementValidation';
import { softDeleteAdvertisement } from '../../../../client/announcements/index'
import ModalDelete from '../../../../components/shared/modals/modalDelete';
import UploadDocumentButton from '../../../../components/shared/uploadDocument';
import DownloadDocumentButton from '../../../../components/shared/downloadDocument';

function SecurePdfViewer({ fileUrl, title }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    setBlobUrl(null);
    setError(false);

    if (!fileUrl) return;

    axiosInstance.get(fileUrl, { responseType: 'blob' })
      .then(response => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setBlobUrl(objectUrl);
      })
      .catch(err => {
        console.error('Error al cargar PDF:', err);
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileUrl]);

  if (error) {
    return (
      <div className="p-8 text-center text-gray-500 font-itcbook">
        El archivo no existe.
      </div>
    );
  }

  if (!blobUrl) {
    return (
      <div className="flex items-center justify-center w-full h-[500px] rounded border">
        <svg className="w-8 h-8 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
        </svg>
      </div>
    );
  }

  return (
    <iframe
      src={blobUrl}
      title={title}
      className="w-full h-[500px] rounded border"
    />
  );
}

export default function AnnouncementsHistorical() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [activeOptionsId, setActiveOptionsId] = useState(null); 

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [adToDelete, setAdToDelete] = useState(null);
  const navigate = useNavigate();

  const handleEdit = (adId) => {
    navigate(`/editar-anuncio/${adId}`);
    setActiveOptionsId(null);
  };

  const handleOpenDelete = (adId) => {
    setAdToDelete(adId);
    setShowDeleteModal(true);
    setActiveOptionsId(null); 
  };

  const toggleOptions = (adId) => {
    if (activeOptionsId === adId) {
      setActiveOptionsId(null); 
    } else {
      setActiveOptionsId(adId); 
    }
  };

  const today = new Date().toLocaleDateString('en-CA', {
    timeZone: 'America/Lima'
  });

  const iconMap = {
    1: dangerIcon,
    2: alertIcon,
    3: checkIcon,
    4: formIcon,
  };

  const excelInputRef = useRef(null);

  const [ads, setAds] = useState([]);
  const [filteredAds, setFilteredAds] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [suppliers, setSuppliers] = useState([]);

  const [notFound, setNotFound] = useState([]);
  const [flaggedSuppliers, setFlaggedSuppliers] = useState([]);
  const [maxExceededSuppliers, setMaxExceededSuppliers] = useState([]);

  const [showNotFound, setShowNotFound] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [showMaxExceeded, setShowMaxExceeded] = useState(false);

  const [showHistoricoModal, setShowHistoricoModal] = useState(false);
  const [historicoSuppliers, setHistoricoSuppliers] = useState([]);

  const [showPublishModal, setShowPublishModal] = useState(false);
  const [publishAdId, setPublishAdId] = useState(null);

  const [loading, setLoading] = useState(false);

  const values = { fromDate, toDate, suppliers };
  const { isValid, errors } = republishValidation(values);
const [downloadingTemplate, setDownloadingTemplate] = useState(false);


  const handleDelete = async () => {
    if (!adToDelete) return;
    
    setLoading(true);
    try {
      await softDeleteAdvertisement(adToDelete);
      setSuccessMessage('¡Anuncio eliminado correctamente!');
      setShowSuccess(true);
      setShowDeleteModal(false);
      fetchAds(); 
    } catch (err) {
      setErrorMessage('Error al eliminar el anuncio.');
      setShowError(true);
    } finally {
      setLoading(false);
      setAdToDelete(null);
    }
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setAdToDelete(null);
  };
const handleExcelChange = async e => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  const validExts = ['xls', 'xlsx'];

  const ext = file.name.split('.').pop().toLowerCase();
  
  if (
    !validTypes.includes(file.type) &&
    !validExts.includes(ext)
  ) {
    setErrorMessage('Formato no válido. Solo se permiten archivos Excel (XLS, XLSX).');
    setShowError(true);
    if (excelInputRef.current) excelInputRef.current.value = '';
    return;
  }

  setLoading(true);
  
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInstance.post('/Advertisement/UploadSuppliers', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    const { validSuppliers, invalidSuppliers } = response.data;
    
    setSuppliers(validSuppliers.map(s => ({
      id: s.id,
      code: s.code,
      name: s.name
    })));
    
    if (invalidSuppliers && invalidSuppliers.length > 0) {
      setNotFound(invalidSuppliers.map(s => s.code).filter(code => code));
      setShowNotFound(true);
    }
    
  } catch (err) {
    console.error('Error al procesar archivo:', err);
    if (err.response?.data?.message) {
      setErrorMessage(err.response.data.message);
    } else {
      setErrorMessage('Error al procesar el archivo Excel.');
    }
    setShowError(true);
  } finally {
    setLoading(false);
    if (excelInputRef.current) excelInputRef.current.value = '';
  }
};

const handleUploadClick = () => {
  if (excelInputRef.current) {
    excelInputRef.current.click();
  }
};

  const handlePublish = async () => {
    if (!isValid) {
      const firstError = errors[Object.keys(errors)[0]];
      setErrorMessage(firstError);
      setShowError(true);
      return;
    }

    setLoading(true);
  if (suppliers.length > 0) {
    const { data: counts } = await axiosInstance.post('/Advertisement/CheckSupplierAdCounts', suppliers.map(s => s.code));
    const exceeded = counts.filter(c => c.activeAdsCount >= 5);
    if (exceeded.length) {
      setMaxExceededSuppliers(exceeded);
      setShowMaxExceeded(true);
      setLoading(false);
      return;
    }

    const flagged = counts.filter(c => c.activeAdsCount >= 3);
    if (flagged.length) {
      setFlaggedSuppliers(flagged);
      setShowConfirm(true);
      setLoading(false);
      return;
    }
  }
    await doPublish();
  };

  const fetchAds = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get('/Advertisement');
      setAds(data);
      setFilteredAds(data);
    } catch (err) {
      console.error('Error al cargar anuncios:', err);
      setErrorMessage('No se pudieron cargar los anuncios.');
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = async (e) => {
    e.preventDefault();
    
    try {
      setDownloadingTemplate(true);
      const response = await axiosInstance.get('/Advertisement/ExportTemplate', {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
        
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'Plantilla_de_proveedores.xlsx';
        
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
        
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
        
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      setErrorMessage('No se pudo descargar el archivo, intenta de nuevo.');
      setShowError(true);
    } finally {
      setDownloadingTemplate(false);
    }
  };

  const handleDownloadFlagged = () => downloadExcel('proveedores_excedidos.xlsx', [
    ['Código', 'Razón Social', 'Cantidad de Anuncios Activos'],
    ...flaggedSuppliers.map(s => [s.supplierCode, s.supplierName, s.activeAdsCount])
  ]);

  const handleDownloadMaxExceeded = () => downloadExcel('proveedores_excedidos.xlsx', [
    ['Código', 'Razón Social', 'Cantidad de Anuncios Activos'],
    ...maxExceededSuppliers.map(s => [s.supplierCode, s.supplierName, s.activeAdsCount])
  ]);

  const downloadHistoric = () => downloadExcel('historico_publicaciones.xlsx', [
    ['Razón Social', 'Inicio', 'Fin'],
    ...historicoSuppliers.map(s => [
      s.name,
      new Date(s.startDate).toLocaleDateString('es-PE', {
        timeZone: 'America/Lima'
      }),
      new Date(s.endDate).toLocaleDateString('es-PE', {
        timeZone: 'America/Lima'
      })
    ])
  ]);

  const handleResetFilters = () => {
    setSearchTerm('');
    setSelectedType('');
    setFilteredAds(ads);
  };

  const handleHistorico = adId => {
    const ad = ads.find(a => a.id === adId);
    if (!ad) return;
    setHistoricoSuppliers(ad.suppliers || []);
    setShowHistoricoModal(true);
  };

  const closeHistorico = () => {
    setShowHistoricoModal(false);
    setHistoricoSuppliers([]);
  };

  const handleOpenPublish = adId => {
    setPublishAdId(adId);
    setFromDate(today);
    setToDate(today);
    setSuppliers([]);
    if (excelInputRef.current) excelInputRef.current.value = '';
    setShowPublishModal(true);
  };

  const doPublish = async () => {
    const formData = new FormData();
    formData.append('adId', publishAdId);
    formData.append('fromDate', fromDate);
    formData.append('toDate', toDate);
    formData.append('suppliers', JSON.stringify(suppliers.map(s => s.code) || []));

    try {
      setLoading(true);
      await axiosInstance.post(`/Advertisement/${publishAdId}/Republish`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      fetchAds();
      setShowPublishModal(false);
      setSuccessMessage('¡Publicación realizada con éxito!');
      setShowSuccess(true);
    } catch (err) {
      setErrorMessage('Error al publicar de nuevo.');
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();
    setFilteredAds(
      ads.filter(ad => {
      let descriptionText = '';
      if (ad.typeId === Types.Advertisement && ad.description) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = ad.description;
        descriptionText = tempDiv.textContent || tempDiv.innerText || '';
      }
      const hayTexto = [
        ad.title, 
        ad.manual?.title, 
        ad.summary,
        descriptionText  
      ]
          .map(f => f?.toLowerCase() || '')
          .some(txt => txt.includes(term));

        const hayTipo = !selectedType
          ? true
          : ad.typeId === Number(selectedType);

        return hayTexto && hayTipo;
      })
    );
  }, [ads, searchTerm, selectedType]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (activeOptionsId !== null && 
        !event.target.closest('.options-button') && 
        !event.target.closest('.options-menu')) {
      setActiveOptionsId(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [activeOptionsId]);

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="sm:pt-8 pt-5 pb-5 sm:px-[3%] px-[5%] flex flex-col gap-2">        
          <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">Historial de Anuncios</h1>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between ">
            <div className="flex flex-col items-start flex-1 min-w-0 gap-2 pt-2 sm:flex-row sm:items-center">
              <label htmlFor="search" className="text-gray-700 font-itcmedium">
                Buscar
              </label>
              <input
                id="search"
                type="text"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                placeholder="Escribe para buscar..."
                className="flex-1 min-w-0 px-3 py-2 border border-gray-300 rounded-lg outline-none placeholder:font-itcbook font-itcbook "
              />
            </div>
            <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center">
              <button
                onClick={handleResetFilters}
                className={`
                  w-full sm:w-auto px-4 py-2 bg-white text-gray-700 font-itcbook rounded-lg shadow-sm transition
                 
                `}
              >
                Reiniciar filtros
              </button>
              <div className="relative w-full sm:w-auto">
                <select
                  value={selectedType}
                  onChange={e => setSelectedType(e.target.value)}
                  className={`
                    appearance-none w-full pl-4 font-itcbook pr-10 py-2 rounded-lg shadow-sm outline-none transition text-center sm:text-left cursor-pointer
                    ${selectedType ? 'bg-blue-light text-white' : 'bg-white text-gray-700'}
                  `}
                >
                  <option value="" className='text-gray-700 bg-white'>Filtrar por tipo</option>
                  <option value={Types.Image} className='text-gray-700 bg-white'>Imagen</option>
                  <option value={Types.Pdf} className='text-gray-700 bg-white'>PDF</option>
                  <option value={Types.Video} className='text-gray-700 bg-white' >Video</option>
                  <option value={Types.Advertisement} className='text-gray-700 bg-white' >Anuncio</option>
                  <option value={Types.Recents} className='text-gray-700 bg-white' >Recientes</option>
                </select>
                <svg
                  className={`
                    pointer-events-none absolute top-1/2 right-3 h-4 w-4 text-gray-700 transform -translate-y-1/2
                    ${selectedType ? 'text-white' : 'text-gray-700'}
                  `}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
          <div className="mt-6 space-y-6">
            {filteredAds.map(ad => {
                const isOptionsOpen = activeOptionsId === ad.id;
              return (
              <div key={ad.id} className='flex flex-col gap-3'>
                <div className="font-itcmedium text-blue">
                  Creado el {new Date(ad.created_At).toLocaleDateString('es-PE', {
                    timeZone: 'America/Lima',
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                  })}
                </div>
                <div className="relative flex flex-col w-full gap-3 p-6 bg-white shadow-lg rounded-2xl">
                  {(ad.title || ad.manual?.title) && (
                    <div>
                      <h2 className="text-xl text-gray-800 font-itcmedium">
                        {ad.title || ad.manual?.title || 'Sin título'}
                      </h2>
                      {ad.summary && 
                        <p className="mt-1 text-gray-600 font-itcbook">
                          {ad.summary}
                        </p>
                      }
                      <div className='w-full my-2 h-[1px] bg-gray-300'></div>
                    </div>
                  )}
                  <div
                    className={ 
                      ` flex ` +
                      (ad.typeId === Types.Advertisement
                        ? 'justify-start'
                        : 'justify-center')
                    }
                  >
                    {(() => {
                      switch (ad.typeId) {
                        case Types.Image:
                          return (
                            <img
                              src={ad.file_url}
                              alt={ad.title}
                              className="max-h-[500px] object-contain rounded"
                            />
                          );
                        case Types.Pdf:
                          return (
                            <SecurePdfViewer fileUrl={ad.file_url} title={ad.summary} />
                          );
                        case Types.Video:
                          const fileUrl = ad.file_url || '';
                          const isGif = fileUrl.toLowerCase().endsWith('.gif') || 
                                        fileUrl.toLowerCase().includes('.gif?') ||
                                        (ad.mimeType && ad.mimeType === 'image/gif');
                          
                          if (isGif) {
                            return (
                              <img
                                src={ad.file_url}
                                alt={ad.title || "Imagen animada GIF"}
                                className="max-h-[500px]  object-contain rounded"
                              />
                            );
                          } else {
                            return (
                              <video
                                src={ad.file_url}
                                controls
                                className="max-h-[500px]  object-contain rounded"
                              />
                            );
                          }
                        case Types.Advertisement:
                          return (
                            <div className="flex items-center justify-start gap-4 text-left ">
                              <img
                                src={iconMap[ad.iconId]}
                                alt="icono"
                                className="w-16 h-16 "
                              />
                              <div
                                className='pr-2 font-itcbook'
                                style={{ 
                                  wordWrap: 'break-word',
                                  wordBreak: 'break-all',
                                  overflowWrap: 'anywhere'
                                }}
                                dangerouslySetInnerHTML={{ __html: ad.description }}
                              />
                            </div>
                          );
                        case Types.Recents:
                          if (!ad.manual || !ad.manual.file) {
                            return (
                              <div className="p-8 text-center text-gray-500 font-itcbook">
                                No hay archivo de manual disponible para este anuncio.
                              </div>
                            );
                          }
                          return (
                            <SecurePdfViewer fileUrl={ad.manual.file} title={ad.summary} />
                          );
                        default:
                          return null;
                      }
                    })()}
                  </div>

                  {/** MENU OPCIONES */}
                  <div className="absolute flex top-2 right-1">
                    <div 
                      className={`cursor-pointer w-6 h-6 rounded-full transition-colors duration-200 options-button 
                        ${isOptionsOpen ? 'bg-[#E8F2F5] ' : ''
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        toggleOptions(ad.id);
                      }}
                      onPointerDown={(e) => e.stopPropagation()} 
                    >
                      <svg onPointerDown={(e) => e.stopPropagation()}  className="relative z-10" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 7C11.4696 7 10.9609 6.78929 10.5858 6.41421C10.2107 6.03914 10 5.53043 10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7ZM12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21Z" fill="#184A7D"/>
                      </svg>
            
                      {isOptionsOpen && (
                        <div className={`absolute z-10 right-4 options-menu`}>
                          <div className="bg-[#184A7D] rounded-lg px-2 w-[42px] h-[75px] grid grid-rows-2 divide-y divide-white">

                            {/** EDITAR */}
                            <button
                              className="flex items-center justify-center w-full h-full"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(ad.id);
                              }}
                            >
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                              </svg>
                            </button>
                            {/** ELIMINAR */}
                            <button 
                            
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveOptionsId(null);
                                  handleOpenDelete(ad.id);
                                }}
                              className="flex items-center justify-center w-full h-full">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.241 4.00616L15.534 6.03516H19.5C19.6989 6.03516 19.8897 6.11417 20.0303 6.25483C20.171 6.39548 20.25 6.58624 20.25 6.78516C20.25 6.98407 20.171 7.17483 20.0303 7.31549C19.8897 7.45614 19.6989 7.53516 19.5 7.53516H18.731L17.858 17.7202C17.805 18.3402 17.762 18.8502 17.693 19.2622C17.623 19.6912 17.516 20.0752 17.307 20.4312C16.9788 20.9903 16.4909 21.4385 15.906 21.7182C15.534 21.8952 15.142 21.9682 14.708 22.0022C14.291 22.0352 13.78 22.0352 13.158 22.0352H10.842C10.22 22.0352 9.709 22.0352 9.292 22.0022C8.858 21.9682 8.466 21.8952 8.094 21.7182C7.50908 21.4385 7.02118 20.9903 6.693 20.4312C6.483 20.0752 6.378 19.6912 6.307 19.2622C6.238 18.8492 6.195 18.3402 6.142 17.7202L5.269 7.53516H4.5C4.30109 7.53516 4.11032 7.45614 3.96967 7.31549C3.82902 7.17483 3.75 6.98407 3.75 6.78516C3.75 6.58624 3.82902 6.39548 3.96967 6.25483C4.11032 6.11417 4.30109 6.03516 4.5 6.03516H8.466L8.759 4.00616L8.77 3.94516C8.952 3.15516 9.63 2.53516 10.48 2.53516H13.52C14.37 2.53516 15.048 3.15516 15.23 3.94516L15.241 4.00616ZM9.981 6.03516H14.018L13.762 4.25916C13.714 4.09216 13.592 4.03516 13.519 4.03516H10.481C10.408 4.03516 10.286 4.09216 10.238 4.25916L9.981 6.03516ZM11.25 10.7852C11.25 10.5862 11.171 10.3955 11.0303 10.2548C10.8897 10.1142 10.6989 10.0352 10.5 10.0352C10.3011 10.0352 10.1103 10.1142 9.96967 10.2548C9.82902 10.3955 9.75 10.5862 9.75 10.7852V15.7852C9.75 15.9841 9.82902 16.1748 9.96967 16.3155C10.1103 16.4561 10.3011 16.5352 10.5 16.5352C10.6989 16.5352 10.8897 16.4561 11.0303 16.3155C11.171 16.1748 11.25 15.9841 11.25 15.7852V10.7852ZM14.25 10.7852C14.25 10.5862 14.171 10.3955 14.0303 10.2548C13.8897 10.1142 13.6989 10.0352 13.5 10.0352C13.3011 10.0352 13.1103 10.1142 12.9697 10.2548C12.829 10.3955 12.75 10.5862 12.75 10.7852V15.7852C12.75 15.9841 12.829 16.1748 12.9697 16.3155C13.1103 16.4561 13.3011 16.5352 13.5 16.5352C13.6989 16.5352 13.8897 16.4561 14.0303 16.3155C14.171 16.1748 14.25 15.9841 14.25 15.7852V10.7852Z" fill="white"/>
                              </svg>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
            
                <div className="flex justify-center gap-3 px-6 pt-3 pb-6">
                  <button
                    onClick={() => handleHistorico(ad.id)}
                    className="px-4 py-2 text-white transition rounded-lg font-itcmedium bg-green"
                  >
                    Histórico
                  </button>
                  <button
                    onClick={() => handleOpenPublish(ad.id)}
                    className="px-4 py-2 text-white transition rounded-lg font-itcmedium bg-blue"
                  >
                    Publicar
                  </button>
                </div>
              </div>
              );
            })}
            {filteredAds.length === 0 && !loading && (
              <p className="text-center text-gray-500 font-itcmedium">No hay anuncios para mostrar.</p>
            )}
          </div>
        </div>
      </div>

      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-60">
          <svg className="w-10 h-10 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
          </svg>
        </div>
      )}

      {showHistoricoModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-[95%] overflow-y-auto max-h-[85%] sm:w-[60%] lg:w-[40%]  p-4 sm:p-6 bg-white rounded-lg shadow-lg">
            <h3 className="mb-4 text-xl font-itcmedium">Histórico de publicaciones</h3>
            <div className="">
              {historicoSuppliers.length > 0 ? (
                historicoSuppliers.map(s => (
                  <div
                    key={s.id}
                    className="flex items-center justify-between w-full gap-3 py-2 text-sm text-gray-700 border-b"
                  >
                    <p className="font-itcmedium break-all md:break-normal w-[70%]">{s.name}</p>
                    <div className='flex gap-2'>
                      <p className='font-itcbook '>
                          Inicio: {new Date(s.startDate).toLocaleDateString('es-PE', {
                            timeZone: 'America/Lima',
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                          })}
                      </p>
                      <p className='font-itcbook '>
                          Fin: {new Date(s.endDate).toLocaleDateString('es-PE', {
                            timeZone: 'America/Lima',
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                          })}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500">No hay registros.</p>
              )}
            </div>
            <div className="mt-6 text-right">
              <button
                onClick={downloadHistoric}
                className="px-4 py-2 mr-2 text-white transition rounded-lg font-itcmedium bg-green"
              >
                Descargar
              </button>
              <button
                onClick={closeHistorico}
                className="px-4 py-2 text-white transition rounded-lg font-itcmedium bg-blue"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {showPublishModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-[95%] max-w-xl p-6 space-y-4 bg-white rounded-lg shadow-lg">
            <h3 className="text-xl font-itcmedium">Publicar Anuncio</h3>
            <div className="flex flex-col gap-4 md:flex-row">
              <div className="flex items-center flex-1 gap-2">
                <label className="text-gray-700 font-itcbook">Desde</label>
                <input
                  type="date"
                  min={today}
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                  className="flex-1 px-3 py-1 border border-gray-300 rounded font-itcbook focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex items-center flex-1 gap-2">
                <label className="text-gray-700 font-itcbook">Hasta</label>
                <input
                  type="date"
                  min={fromDate}
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                  className="flex-1 px-3 py-1 border border-gray-300 rounded font-itcbook focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            <div>
              <UploadDocumentButton
                text='Subir lista de proveedores'
                isEnabled={true}
                onClick={handleUploadClick}
              />
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  className="hidden"
                  ref={excelInputRef}
                  onChange={handleExcelChange}
                />
            </div>
            <div>

            <DownloadDocumentButton 
              text="Descargar plantilla"
              onClick={handleDownloadTemplate}
              disabled={downloadingTemplate}
              loading={downloadingTemplate}
              hasData={true}
            />


            </div>
            {suppliers.length > 0 && (
              <div className="p-4 bg-white border border-gray-200 rounded-md shadow">
                <h4 className="mb-2 font-itcmedium text-blue">Proveedores:</h4>
                <ul className="text-gray-700 list-disc list-inside font-itcbook">
                  {suppliers.map((sup) => (
                    <li key={sup.code}>{sup.name} (Código: {sup.code})</li>
                  ))}
                </ul>
              </div>
            )}
            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setShowPublishModal(false)}
                className="px-4 py-2 border rounded-lg font-itcmedium hover:bg-gray-100"
              >
                Cancelar
              </button>
              <button
                onClick={handlePublish}
                className="px-4 py-2 text-white rounded-lg font-itcmedium bg-blue"
              >
                Publicar
              </button>
            </div>
          </div>
        </div>
      )}

      <Modals
        showNotFound={showNotFound} notFound={notFound} onCloseNotFound={() => setShowNotFound(false)}
        showError={showError} errorMessage={errorMessage} onCloseError={() => setShowError(false)}
        showSuccess={showSuccess} successMessage={successMessage} onCloseSuccess={() => setShowSuccess(false)}
        showConfirm={showConfirm} flaggedSuppliers={flaggedSuppliers} onConfirm={() => { setShowConfirm(false); doPublish(); }} onDownloadFlagged={handleDownloadFlagged} onCloseConfirm={() => setShowConfirm(false)}
        showMaxExceeded={showMaxExceeded} maxExceededSuppliers={maxExceededSuppliers} onDownloadMaxExceeded={handleDownloadMaxExceeded} onCloseMaxExceeded={() => setShowMaxExceeded(false)}
      />

      <ModalDelete
        showModalDelete={showDeleteModal}
        closeModal={closeDeleteModal}
        accept={handleDelete}
        textType="anuncio"
        pronoun="el"
      />
    </div>
  );
}